import Vue from 'vue'
import { nSQL } from "@nano-sql/core"
import {getMode} from "@nano-sql/adapter-sqlite-cordova"

const DATABASE_NAME = 'minicaq_app_004';

export const DB = new Vue({
  data: {
    name: DATABASE_NAME,
  },

  methods: {
    setup: function () {
      return nSQL().createDatabase({
        id: this.name,
        mode: getMode(),
        tables: [
          {
            name: "users",
            model: {
              "id:int": {pk: true},
              "first_name:string": {},
              "last_name:string": {},
              "email:string": {},
              "password:string": {},
              "token:string": {},
              "district_ids:array": {},
            }
          },
          {
            name: "settings",
            model: {
              "name:string": {pk: true},
              "value:string": {},
            }
          },
          {
            name: "solicitation_assignations",
            model: {
              "id:int": {pk: true},
              "campaign_type:string": {},
              "district_id:int": {},
              "district_name:string": {},
              "district_candidate:string": {},
              "label:string": {},
              "manager:string": {},
              "manager_email": {},
              "manager_id:int": {},
              "user_id:int": {},
              "date_start:int": {},
              "date_end:int": {},
              "script:string": {},
              "sections_list:string": {},
              "total_qualified:int": {},
              "total_scored:int": {},
              "pulled_at:int": {},
              "remotely_deleted:bool": {},
            }
          },
          {
            name: "solicitation_lists",
            model: {
              "local_id:string": {pk: true},
              "solicitation_assignation_id:int": {},
              "address:string": {},
              "age:int": {},
              "app:string": {},
              "city:string": {},
              "civic_number:string": {},
              "complete_address:string": {},
              "courtoisie:string": {},
              "district_id:int": {},
              "email:string": {},
              "expecting_time_vote:int": {},
              "field_id:int": {},
              "first_name:string": {},
              "gender:string": {},
              "has_answered:bool": {},
              "has_been_called:bool": {},
              "is_family:bool": {},
              "last_call_at:int": {},
              "last_name:string": {},
              "link_map:string": {},
              "map_latitude:float": {},
              "map_longitude:float": {},
              "member_link:string": {},
              "notes:string": {},
              "phone_household:string": {},
              "phone_principal:string": {},
              "postal_code:string": {},
              "ranking:int": {},
              "remove_from_list:bool": {},
              "score:string": {},
              "section_number:int": {},
              "solicitation_date:int": {},
              "vote_date:int": {},
              "voter_id:int": {},
              "voter_number:int": {},
              "send_membership_form_link:bool": {default:false},
              "send_election_location:bool": {default:false},
              "send_candidate_bio:bool": {default:false},
              "selected_issues_ids:array": {default:[]},
              "pushed_at:int": {},
              "pulled_at:int": {},
              "locally_updated_at:int": {},
              "locally_deleted:bool": {default:false},
              "locally_updated_attributes:object": {default:{}},
              "remotely_deleted:bool": {default:false},
            }
          },
          {
            name: "solicited_voters",
            model: {
              "id:int": {pk: true},
              "address:string": {},
              "app:string": {},
              "birth_date:string": {},
              "city:string": {},
              "civic_number:string": {},
              "complete_address:string": {},
              "courtoisie:string": {},
              "district_id:int": {},
              "district_militancy:int": {},
              "email:string": {},
              "field_id:int": {},
              "first_name:string": {},
              "gender:string": {},
              "is_family:bool": {},
              "is_member:bool": {},
              "lang:string": {},
              "last_name:string": {},
              "link_map:string": {},
              "map_latitude:float": {},
              "map_longitude:float": {},
              "member_link:string": {},
              "membership_type:string": {},
              "phone_household:string": {},
              "phone_principal:string": {},
              "postal_code:string": {},
              "ranking:int": {},
              "rankingDate:int": {},
              "section_number:int": {},
              "sector_number:int": {},
              "total_contribution:float": {},
              "total_contribution_diff:float": {},
              "updated_at:int": {},
              "voter_number:int": {},
              "pulled_at:int": {},
            }
          },
          {
            name: "direct_scorings",
            model: {
              "local_id:string": {pk: true},
              "locally_updated_at:int": {},
              "locally_deleted:bool": {},
              "user_id:int": {},
              "last_name:string": {},
              "first_name:string": {},
              "birth_date:string": {},
              "district_id:int": {},
              "score:string": {},
              "email:string": {},
              "postal_code:string": {},
              "phone_principal:string": {},
              "pushed_at:int": {},
              "civic_number:string": {},
            },
          },
        ],
        version: 1,
        onVersionUpdate: (prevVersion) => {
          return new Promise((res) => {
            switch (prevVersion) {
              case 1:
                // migrate v1 to v2
                res(2);
                break;
              case 2:
                // migrate v2 to v3
                res(3);
                break;
            }

          });
        }
      });
    }
  },
});
